import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import swal from "sweetalert";
import { RootState, AppThunk } from "../../app/store";
import { UpdateCalendar } from "./learningAPI";

export interface CalendarState {
  updatecalendar: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: CalendarState = {
    updatecalendar: [],
  status: "idle",
};

export const GetUpdateCalendar = createAsyncThunk(
  "document/fetchDocument",
  async (data:any) => {
    const response = await UpdateCalendar(data);
    return response;
  }
);

export const UpdateCalendarSlice = createSlice({
  name: "Document",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUpdateCalendar.pending, (state) => {
        state.status = "loading";
      }) 
      .addCase(GetUpdateCalendar.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetUpdateCalendar.fulfilled, (state, action) => {
        state.status = "idle";
        state.updatecalendar = action.payload;
        //swal("Record update success22222!",  "success");
      });
  },
});

export const {} = UpdateCalendarSlice.actions;

export const selectUpdateCalendar = (state: RootState) => {
  return state.UpdateCalendar.updatecalendar;
};

export default UpdateCalendarSlice.reducer;
